import PricePerUnitLegalModal, { LEGAL_COPY } from './PricePerUnitLegalModal';

export default PricePerUnitLegalModal;
export { LEGAL_COPY };
